import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import {
    Row,
    Col,
    Card,
    Container,
    ListGroup,
    Form,
    Button,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import { Spin, Progress } from "antd";
import { setUploadFile } from "../../../actions/scenarioVariationUpload/uploadFile";
import {
    uploadInuputFilesForVariationCreation,
    resetMasterFileUpload,
    resetUploadStatus,
} from "../../../actions/scenarioVariationUpload/uploadInputFiles";
import UploadInputProgress from "./uploadProgress/uploadInputProgressEnhanced";
import { scenarioVariationGeneration, cleanData } from "../../UserFunctions";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import {
    fetchSimulatorInfo,
    fetchModelInfo,
} from "../../../actions/closeLoop/scenarioCollection/dropDownModalAction";
import PropTypes from "prop-types";

const ScenarioVariationUpload = (props) => {
    const [buttonPushPopUp, setbuttonPushPopUp] = useState(false);
    const [buttonPushPopUpCleanFiles, setbuttonPushPopUpCleanFiles] = useState(false);
    const [popupNoInputFiles, setPopupNoInputFiles] = useState(false);
    const [progress, setProgress] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [componentStatus, setComponentStatus] = useState(false);
    const [simulator, setsimulator] = useState("");
    const [model, setModel] = useState("");
    // const [bulkUploadFiles, setBulkUploadFiles] = useState(false);
    const [uploadInputFiles, setUploadInputFiles] = useState(false);
    const [generateSuccess, setGenerateSuccess] = useState(false);

    const loadingTip = "Loading...";

    const [statusInfo, setStatusInfo] = useState({
        totalVariationsCount: 0,
        totalBaseScenarioVariationsGenerated: 0,
        totalBaseScenario: 0,
        percentageCompleted: 0,
    });

    const payload = { simulatorName: simulator, modelName: model, generateStatus: loading };
    useEffect(() => {
        props.simulatorList();
        if (loading) {
            const timeout = setInterval(() => {
                console.log("payload", payload);
                scenarioVariationGeneration("/create_variations", payload).then((res) => {
                    console.log("response creation", res);
                    if (res) {
                        if (res.data.data !== "No_input_files") {
                            if (res.data.data.status === "in_progress") {
                                console.log(
                                    "Input files are present.Generation of scenario variations process in progress.with "
                                );
                                setProgress(true);
                                setLoading(true);
                                let output = res.data.data;
                                let percentage = 0;
                                if (output.total_base_scenario !== 0) {
                                    percentage = parseInt(
                                        (output.total_base_scenario_variations_generated /
                                            output.total_base_scenario) *
                                            100
                                    );
                                }
                                setStatusInfo({
                                    totalVariationsCount: output.total_variations_count,
                                    totalBaseScenarioVariationsGenerated:
                                        output.total_base_scenario_variations_generated,
                                    totalBaseScenario: output.total_base_scenario,
                                    percentageCompleted: percentage,
                                });
                                setShow(!show);
                                // } else if (res.data.data === "input_files_present") {
                                //     setShow(!show);
                                //     setLoading(true);
                            } else if (res.data.data === "success") {
                                cleanLoader();
                                setLoading(false);
                                setProgress(false);
                                setStatusInfo({
                                    totalVariationsCount: 0,
                                    totalBaseScenarioVariationsGenerated: 0,
                                    totalBaseScenario: 0,
                                    percentageCompleted: 0,
                                });
                                setGenerateSuccess(true);
                                alert("Generation of scenario variations process is completed.");
                                // document.getElementById("close_loop_bulk_scenario_sdd_upload").value = "";
                                // document.getElementById("close_loop_master_xosc_upload").value = "";
                                props.resetUploadStatus();
                            }
                        } else {
                            setLoading(false);
                            setProgress(false);
                            // alert("Input files are not present.")
                        }
                    }
                });
            }, 5000);
            return () => clearInterval(timeout);
        }
    }, [show]);

    function cleanLoader() {
        setLoading(false);
        setShow(!show);
    }
    useEffect(() => {
        if (loading) {
            const handleTabClose = (event) => {
                console.log(event.returnValue);
                return (event.returnValue = "Are you sure you want to exit?");
            };
            window.addEventListener("beforeunload", handleTabClose);
            return () => {
                window.removeEventListener("beforeunload", handleTabClose);
            };
        }
    }, [loading]);
    // const handleAttachFile = (e) => {
    //     e.preventDefault();
    //     const uploadInput = document.getElementById("close-loop-upload-files");
    //     console.log(uploadInput.files);
    //     //const fileName = uploadInput.files[0].name;
    //     props.setUploadFile(uploadInput.files, "local-filesystem");
    //     uploadInput.value = ""; // to clear the current file field
    // };

    const handleCloseGenerateVariation = () => {
        setbuttonPushPopUp(false);
    };

    const handleGenerateVariation = () => {
        setbuttonPushPopUp(true);
    };

    const handleCloseCleanFiles = () => {
        setbuttonPushPopUpCleanFiles(false);
    };

    const handleCleanFiles = () => {
        setbuttonPushPopUpCleanFiles(true);
    };

    const handleCloseNoInputFiles = () => {
        setPopupNoInputFiles(false);
    };

    const onComponentStatus = () => {
        setComponentStatus(!componentStatus);
        if(componentStatus){
            document.getElementById("fa_double_up").style.display="none"
            document.getElementById("fa_double_down").style.display="block"
        }else{
            document.getElementById("fa_double_down").style.display="none"
            document.getElementById("fa_double_up").style.display="block"
        }
    };

    const SubmitData = () => {
        setLoading(true);
        scenarioVariationGeneration("/create_variations", payload).then((res) => {
            if (res.data.data !== "No_input_files") {
                setShow(!show);
                setLoading(true);
                if (res.data.data === "in_progress") {
                    alert("Generation of scenario variations process in progress.");
                }
                if (res.data.data === "success") {
                    setLoading(false);
                    setGenerateSuccess(true);
                    alert("Generation of scenario variations process is completed.");
                    // document.getElementById("close_loop_bulk_scenario_sdd_upload").value = "";
                    // document.getElementById("close_loop_master_xosc_upload").value = "";
                }
            } else {
                setPopupNoInputFiles(true);
            }
        });
        handleCloseGenerateVariation();
    };

    const CleanFiles = () => {
        cleanData("/clean_data").then((res) => {
            if (res.data.data === "success") {
                alert("Cleaning of scenario variation input folders done. ");
                console.log(res);
            } else {
                alert("Cleaning of the input folder failed. Please try again. ");
            }
        });
        cleanLoader();
        setGenerateSuccess(false)
        setLoading(false);
        setProgress(false);
        setStatusInfo({
            totalVariationsCount: 0,
            totalBaseScenarioVariationsGenerated: 0,
            totalBaseScenario: 0,
            percentageCompleted: 0,
        });
        handleCloseCleanFiles();
        props.resetUploadStatus();
        setGenerateSuccess(false);
        setUploadInputFiles(false);
        document.getElementById("masterXoscValidate").innerHTML = "";
        document.getElementById("sddValidate").innerHTML = "";
        document.getElementById("close_loop_bulk_scenario_sdd_upload").value = "";
        document.getElementById("close_loop_master_xosc_upload").value = "";
    };

    let simOptions = [];
    if (props.simulatorListInfo.length > 0) {
        simOptions = props.simulatorListInfo.map((simLabel) => {
            return { label: simLabel, value: simLabel };
        });
        if (simulator === "") {
            setsimulator(simOptions[0].label);
            props.modelList(simOptions[0].label);
        }
    } else {
        simOptions = [];
    }

    let modelOptions = [];
    if (props.modelListInfo.length > 0) {
        modelOptions = props.modelListInfo.map((modelLabel) => {
            return { label: modelLabel, value: modelLabel };
        });
        if (model === "") {
            setModel(modelOptions[0].label);
        }
    } else {
        modelOptions = [];
    }

    const handleUploadInputFiles = (e) => {
        e.preventDefault();
        const fileSystem = "local-filesystem";
        let xoscValidationText;
        let sddValidationText;
        // let file;
        // let checkMasterFile;
        // const masterXoscDict = {};
        let masterSc;
        var checkXoscValidFile = true;
        var sddValidationFile = true;
        const uploadMasterInput = document.getElementById("close_loop_master_xosc_upload");
        for (let i = 0; i < uploadMasterInput.files.length; i++) {
            // file = uploadMasterInput.files[i].name;
            // checkMasterFile = file.split("_").pop()
            // if(checkMasterFile.startsWith("master")){
            // masterXoscDict[i] = uploadMasterInput.files[i];
            masterSc = uploadMasterInput.files[i].name;
            let masterScName;
            masterScName = masterSc.split(".")[0];
            if (masterSc.startsWith("SC_ADHWY")) {
                if (masterScName.endsWith("master")) {
                    setGenerateSuccess(true)
                } else {
                    setGenerateSuccess(false)
                    checkXoscValidFile = false;
                }
            } else {
                checkXoscValidFile = false;
                setGenerateSuccess(false)
            }
            // }
            // console.log("dict", masterXoscDict);
        }
        // if (checkXoscValidFile === true) {
        //     xoscValidationText = "valid File";
        const sddFileUpload = document.getElementById("close_loop_bulk_scenario_sdd_upload");
        const sddFile = sddFileUpload.files[0];
        const sddFileName = sddFileUpload.files[0].name;
        if (
            sddFileName.startsWith("Scenario_Description_Document") &&
            sddFileName.endsWith(".xlsx")
        ) {
            sddValidationFile = true;
        } else {
            sddValidationFile = false;
        }
        if (checkXoscValidFile === true && sddValidationFile == true) {
            xoscValidationText = "valid File";
            sddValidationText = "valid File";
            setUploadInputFiles(true);
            props.uploadInuputFilesForVariationCreation(
                uploadMasterInput.files,
                sddFile,
                fileSystem,
                simulator,
                model
            );
            // uploadMasterInput.value = ""; // to clear the current file field
            // sddFileUpload.value = "";
        } else if (checkXoscValidFile == false && sddValidationFile == true) {
            sddValidationText = "valid File";
            checkXoscValidFile = true;
            xoscValidationText =
                "Invalide File. Please upload file with name SC_ADHWY_'<'scenario category'>'_'<'feature'>'_master.xosc eg. SC_ADHWY_TJP_8b_master.xosc";
        } else if (checkXoscValidFile == true && sddValidationFile == false) {
            sddValidationFile = true;
            sddValidationText =
                "Invalide File. Please upload file with name Scenario_Description_Document_'<'name'>'.xlsx eg. Scenario_Description_Document_OpenX_latest.xlsx";
            xoscValidationText = "valid File";
        } else {
            checkXoscValidFile = true;
            sddValidationFile = true;
            xoscValidationText =
                "Invalide Master XOSC File. Please upload file with name SC_ADHWY_'<'scenario category'>'_'<'feature'>'_master.xosc eg. SC_ADHWY_TJP_8b_master.xosc";
            sddValidationText =
                "Invalid File. Please upload file with name Scenario_Description_Document_'<'name'>'.xlsx eg. Scenario_Description_Document_OpenX_latest.xlsx";
        }
        document.getElementById("masterXoscValidate").innerHTML = xoscValidationText;
        document.getElementById("sddValidate").innerHTML = sddValidationText;
    };

    if (props.masterInputFilesUploadStatus.uploadStatus) {
        props.resetProgress();
    }
    return (
        <>
            <Spin spinning={loading} tip={loadingTip}>
                <Container data-test="scenarioFileUploadComponent" className="mt-5">
                    <Row>
                        <Col>
                            <Card>
                                <Card.Header
                                    className="mb-2"
                                    style={{ backgroundColor: "#757AF7" }}
                                >
                                    <Row>
                                        <Col md={11} sm={5}>
                                            <h4 style={{ color: "#FFFFFF" }}>
                                                Upload File(s) to create Variations
                                            </h4>
                                        </Col>
                                        <Col md={1} sm={7}>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="reset-folder">
                                                        <strong>
                                                            It will do clean up of scenario
                                                            variation input folder
                                                        </strong>
                                                    </Tooltip>
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    style={{
                                                        backgroundColor: "#FFFFFF",
                                                        color: "#757AF7",
                                                    }}
                                                    onClick={handleCleanFiles}
                                                    data-test="clickComponent"
                                                >
                                                    Reset
                                                </Button>
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    {/* <Form onSubmit={handleAttachFile}> */}
                                    <Form onSubmit={handleUploadInputFiles}>
                                        <Row>
                                            <Col>
                                                <Card>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col>
                                                                <h4>Uploading Status</h4>
                                                            </Col>
                                                            <Col
                                                                style={{
                                                                    border: "1px solid #e5dada",
                                                                    backgroundColor: "#e2e3ff",
                                                                }}
                                                            >
                                                                {!generateSuccess
                                                                    ? !uploadInputFiles
                                                                        ? "Please choose the files to be uploaded and then click on upload"
                                                                        : !props
                                                                              .masterInputFilesUploadStatus
                                                                              .uploadStatus
                                                                        ? "Uploading master xosc and sdd file in progress...!"
                                                                        : "Uploading master xosc and sdd file completed. please click on generate variation"
                                                                    : " Scenario variation creation successfully completed"}
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col>
                                                                <h4>Select Master Xosc File:</h4>
                                                            </Col>
                                                            <Col>
                                                                <input
                                                                    type="file"
                                                                    directory=""
                                                                    webkitdirectory=""
                                                                    className="form-control"
                                                                    multiple
                                                                    // id="close-loop-upload-files"
                                                                    id="close_loop_master_xosc_upload"
                                                                    style={{ border: "0rem" }}
                                                                    required
                                                                />
                                                                <p
                                                                    style={{ color: "#FF0000" }}
                                                                    id="masterXoscValidate"
                                                                ></p>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col>
                                                                <h4>Select Scenario SDD File:</h4>
                                                            </Col>
                                                            <Col>
                                                                <input
                                                                    type="file"
                                                                    className="form-control"
                                                                    // multiple
                                                                    id="close_loop_bulk_scenario_sdd_upload"
                                                                    style={{ border: "0rem" }}
                                                                    required
                                                                />
                                                                <p
                                                                    style={{ color: "#FF0000" }}
                                                                    id="sddValidate"
                                                                ></p>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col>
                                                                <h4>Simulator :</h4>
                                                            </Col>
                                                            <Col>
                                                                <Form.Control
                                                                    as="select"
                                                                    required
                                                                    value={simulator}
                                                                    onChange={(e) => {
                                                                        setsimulator(
                                                                            e.target.value
                                                                        );
                                                                        props.modelList(
                                                                            e.target.value
                                                                        );
                                                                    }}
                                                                >
                                                                    {simOptions.map(
                                                                        (item, index) => (
                                                                            <option
                                                                                key={`simulator-${index}`}
                                                                                value={item.value}
                                                                            >
                                                                                {item.label}
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Form.Control>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col>
                                                                <h4>Model :</h4>
                                                            </Col>
                                                            <Col>
                                                                <Form.Control
                                                                    as="select"
                                                                    required
                                                                    value={model}
                                                                    onChange={(e) =>
                                                                        setModel(e.target.value)
                                                                    }
                                                                >
                                                                    {modelOptions.map(
                                                                        (item, index) => (
                                                                            <option
                                                                                key={`model-${index}`}
                                                                                value={item.value}
                                                                            >
                                                                                {item.label}
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Form.Control>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col className="text-center">
                                                            <Button
                                                                type="submit"
                                                                style={{
                                                                    backgroundColor: "#757AF7",
                                                                    color: "#FFFFFF",
                                                                }}
                                                                disabled={generateSuccess}
                                                            >
                                                                Upload
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <Row className="mt-2">
                                        <Col>
                                            <ListGroup.Item>
                                                <Row>
                                                    <Col className="text-center">
                                                        <Button
                                                            type="submit"
                                                            style={{
                                                                backgroundColor: "#757AF7",
                                                                color: "#FFFFFF",
                                                            }}
                                                            onClick={handleGenerateVariation}
                                                            data-test="clickComponent"
                                                            disabled={
                                                                !props.masterInputFilesUploadStatus
                                                                    .uploadStatus
                                                            }
                                                        >
                                                            Generate Variation
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Spin>
            <UploadInputProgress />
            {progress ? (
                <Modal isOpen={true}>
                    <ModalHeader>
                        <Button
                            type="submit"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                            }}
                            onClick={handleCleanFiles}
                            data-test="clickComponent"
                        >
                            Stop
                        </Button>
                    </ModalHeader>
                    <ModalBody>
                        <h3>Base Scenario Variation Generation</h3>
                        <Progress
                            strokeColor={{
                                from: "#757AF7",
                                to: "#B0FF44",
                            }}
                            percent={statusInfo.percentageCompleted}
                            status="active"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            data-toggle="collapse"
                            data-target="#components-card"
                            aria-controls="components-card"
                            onClick={onComponentStatus}
                            id = 'btn_collapse'
                            style={{
                                border: "0px",
                                color: "#FFFFFF",
                                backgroundColor: "#9296ff",
                            }}
                        >
                            <div id="fa_double_down"> <i className="fas fa-angle-double-down" ></i></div>
                            <div id="fa_double_up" style={{display:'none'}}> <i className="fas fa-angle-double-up"></i></div>
                        </Button>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="collapse" id="components-card">
                                    <p style={{ margin: "0px" }}>
                                        Total Number of Base Scenarios :{" "}
                                        {statusInfo.totalBaseScenario}
                                    </p>
                                    <p style={{ margin: "0px" }}>
                                        No of Base Scenario Variations Generated :{" "}
                                        {statusInfo.totalBaseScenarioVariationsGenerated}
                                    </p>
                                    <p style={{ margin: "0px" }}>
                                        Total Generated Variations Count :{" "}
                                        {statusInfo.totalVariationsCount}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            ) : undefined}
            {buttonPushPopUp ? (
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={handleCloseGenerateVariation}
                        style={{ backgroundColor: "#753DFF" }}
                    ></ModalHeader>
                    <ModalBody>
                        <p>Do you want to generate the scenario variations ?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ marginLeft: "70%", color: "#FFFFFF" }}
                            onClick={SubmitData}
                        >
                            Yes
                        </Button>
                        <Button
                            className="btn"
                            style={{ marginRight: "40%", backgroundColor: "red", color: "#FFFFFF" }}
                            onClick={handleCloseGenerateVariation}
                        >
                            No
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
            {buttonPushPopUpCleanFiles ? (
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={handleCloseCleanFiles}
                        style={{ backgroundColor: "#753DFF" }}
                    ></ModalHeader>
                    <ModalBody>
                        <p>Do you want to clean all the files ?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ marginLeft: "70%", color: "#FFFFFF" }}
                            onClick={CleanFiles}
                        >
                            Yes
                        </Button>
                        <Button
                            className="btn"
                            style={{ marginRight: "40%", backgroundColor: "red", color: "#FFFFFF" }}
                            onClick={handleCloseCleanFiles}
                        >
                            No
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
            {popupNoInputFiles ? (
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={handleCloseNoInputFiles}
                        style={{ backgroundColor: "#753DFF" }}
                    ></ModalHeader>
                    <ModalBody>
                        <p>
                            There are no input files. please upload required input files to generate
                            scenario variations
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ marginLeft: "70%" }}
                            onClick={handleCloseNoInputFiles}
                        >
                            Ok
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
        </>
    );
};

ScenarioVariationUpload.propTypes = {
    setUploadFile: PropTypes.func,
    simulatorListInfo: PropTypes.array,
    modelListInfo: PropTypes.array,
    simulatorList: PropTypes.func,
    modelList: PropTypes.func,
};

const mapStateToProps = (state) => ({
    simulatorListInfo: state.DropDownSimulatorData.simulatorListInfo,
    modelListInfo: state.DropDownModelData.modelListInfo,
    masterInputFilesUploadStatus: state.masterInputFilesUploadStatusReducer,
    // simulatorErrorStatus: state.DropDownSimulatorData.error,
    // modalErrorStatus: state.DropDownModelData.error,
});

const mapDispatchToProps = (dispatch) => ({
    setUploadFile: (files, fileSystem, scenarioListFile, scenarioSDDFile) =>
        dispatch(setUploadFile(files, fileSystem, scenarioListFile, scenarioSDDFile)),
    simulatorList: () => dispatch(fetchSimulatorInfo()),
    modelList: (simulator) => dispatch(fetchModelInfo(simulator)),
    resetProgress: () => dispatch(resetMasterFileUpload()),
    uploadInuputFilesForVariationCreation: (
        masterScenarioFiles,
        sddFile,
        fileSystem,
        simulator,
        model
    ) =>
        dispatch(
            uploadInuputFilesForVariationCreation(
                masterScenarioFiles,
                sddFile,
                fileSystem,
                simulator,
                model
            )
        ),
    resetUploadStatus: () => dispatch(resetUploadStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioVariationUpload);
